export default __webpack_public_path__ + "c6960feb0e4e7ff2e9ed9573d5eb235b.svg";